
import {
  defineComponent, onMounted, ref, Ref,
} from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';
import { Pagination } from 'swiper';
import AppButton from '@/components/UI/AppButton.vue';
import 'swiper/swiper-bundle.css';
// eslint-disable-next-line import/no-cycle
import PaymentService from '@/modules/payment/services/PaymentService';
import { IAvailableProducts } from '@/types/interfaces';

export default defineComponent({
  components: {
    AppButton,
    Swiper,
    SwiperSlide,
  },
  setup() {
    const availableProducts: Ref<IAvailableProducts[]> = ref([]);

    onMounted(() => {
      PaymentService.fetchAvailableProducts().then((response) => {
        if (response.success) {
          availableProducts.value = response.results.data;
        }
      });
    });

    return {
      modules: [Pagination],
      availableProducts,
    };
  },
});
